<template>
    <div class="letter-recievers-groups">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a :href=route_back>Список отправителей</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Добавить отправителя</li>
            </ol>
        </nav>

        <div class="template-add_input">
            <div class="text-input-group">
                <div class="mb-4 input-field">
                    <label class="form-label">Имя отправителя <span class="color-red">*</span></label>
                    <input v-model="name" type="text" class="form-control" placeholder="">
                </div>
            </div>

            <div class="mb-4 input-field">
                <label class="form-label">Email адрес <span class="color-red">*</span></label>
                <div class="w-100 d-flex">
                    <input v-model="emailName" type="text" class="form-control w-50">
                    <span class="w-50 d-inline mt-2">{{ mail_domain }}</span>
                </div>
            </div>

            <div class="mb-4">
                <label class="form-label">Хедер шаблона письма <span class="color-red">*</span></label>
                <TinyMCE
                    :init="headerEditorConfig"
                    v-model="headerContent"
                />
            </div>

            <div class="mb-4">
                <label class="form-label">Футер шаблона письма <span class="color-red">*</span></label>
                <TinyMCE
                    :init="footerEditorConfig"
                    v-model="footerContent"
                />
            </div>

            <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
                <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createSender"/>
                <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
            </div>
            <Alert />
        </div>
    </div>
</template>

<script>
import '/tinymce/tinymce.min.js';
import '/tinymce/icons/default/icons.min.js';
import '/tinymce/themes/silver/theme.min.js';
import '/tinymce/models/dom/model.min.js';
import TinyMCE from '@tinymce/tinymce-vue';
import SenderLetter from '../../../../models/Mailings/SenderLetter'
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';

export default {
    name: 'SendersAddComponent',
    components: {
        Alert, TinyMCE, ConfirmBtn
    },
    props: {
        route_back: String,
        route_create: String,
        mail_domain: String,
        tinymce_keys: [Object]
    },
    data: function () {
        return {
            name: '',
            emailName: '',
            header: '',
            footer: '',
            document_base_url: '',
            headerContent: '',
            footerContent: '',
            tinymceKeys: [
                this.tinymce_keys.primary,
                this.tinymce_keys.spare
            ],
            editorIndex: 0,
            keyIndex: null,
            headerEditorInstance: null,
            footerEditorInstance: null,
            sender: new SenderLetter({
                route_create: this.route_create
            })
        };
    },
    computed: {
        headerEditorConfig() {
            return {
                language: 'ru',
                base_url: '/tinymce',
                suffix: '.min',
                plugins: [
                    'image', 'autoresize', 'code', 'media', 'autolink',
                    'table', 'lists', 'preview', 'link'
                ],
                toolbar1:
                    'newdocument | insertfile undo redo | bold italic underline strikethrough | ' +
                    'alignleft aligncenter alignright alignjustify | cut copy paste link | numlist bullist | ' +
                    'tabulation outdent indent | image media | code | table styleselect formatselect fontselect fontsizeselect | ' +
                    'removeformat | preview',
                toolbar_mode: 'wrap',
                toolbar_sticky: false,
                min_height: 400,
                image_advtab: true,
                file_picker_types: 'file image media',
                default_link_target: '_blank',
                link_context_toolbar: true,
                relative_urls: false,
                remove_script_host: false,
                link_title: false,
                document_base_url: this.document_base_url,
                paste_as_text: false,
                paste_data_images: true,
                paste_merge_formats: false,
                valid_elements: '*[*]',
                paste_webkit_styles: 'all',
                content_style: 'body { max-width: 600px; margin: 0 auto; }',
                setup: (editor) => {
                    this.headerEditorInstance = editor;

                    editor.ui.registry.addButton('tabulation', {
                        icon: 'chevron-right',
                        tooltip: 'Отступ строки',
                        onAction: () => {
                            editor.execCommand('mceInsertContent', false, '&nbsp;&nbsp;&nbsp;&nbsp;');
                        }
                    });
                },
                images_upload_handler: this.uploadFunction,
            };
        },
        footerEditorConfig() {
            return {
                language: 'ru',
                base_url: '/tinymce',
                suffix: '.min',
                plugins: [
                    'image', 'autoresize', 'code', 'media', 'autolink',
                    'table', 'lists', 'preview', 'link'
                ],
                toolbar1:
                    'newdocument | insertfile undo redo | bold italic underline strikethrough | ' +
                    'alignleft aligncenter alignright alignjustify | cut copy paste link | numlist bullist | ' +
                    'tabulation outdent indent | image media | code | table styleselect formatselect fontselect fontsizeselect | ' +
                    'removeformat | preview',
                toolbar_mode: 'wrap',
                toolbar_sticky: false,
                min_height: 400,
                image_advtab: true,
                file_picker_types: 'file image media',
                default_link_target: '_blank',
                link_context_toolbar: true,
                relative_urls: false,
                remove_script_host: false,
                link_title: false,
                document_base_url: this.document_base_url,
                paste_as_text: false,
                paste_data_images: true,
                paste_merge_formats: false,
                valid_elements: '*[*]',
                paste_webkit_styles: 'all',
                content_style: 'body { max-width: 600px; margin: 0 auto; }',
                setup: (editor) => {
                    this.footerEditorInstance = editor;

                    editor.ui.registry.addButton('tabulation', {
                        icon: 'chevron-right',
                        tooltip: 'Отступ строки',
                        onAction: () => {
                            editor.execCommand('mceInsertContent', false, '&nbsp;&nbsp;&nbsp;&nbsp;');
                        }
                    });
                },
                images_upload_handler: this.uploadFunction,
            };
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createSender: async function () {
            if (this.name === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите имя отправителя' });
                this.toggleLoading();
                return;
            }

            if (this.emailName === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите имя электронной почты отправителя' });
                this.toggleLoading();
                return;
            }

            let formData = new FormData();

            formData.append('name', this.name);
            formData.append('email', this.emailName);
            formData.append('header', this.headerEditorInstance.getContent());
            formData.append('footer', this.footerEditorInstance.getContent());

            let result = await this.sender.create(formData);

            if (result) {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Ошибка при добавлении отправителя' });
            }
        },
        uploadFunction:  function(blobInfo, success, failure) {
			return new Promise((resolve, reject) => {
				const FormRequest = new FormData();
				FormRequest.append('image', blobInfo.blob());
				let imgUrl = null;
				axios.post('/technical/letter-constructor/upload', FormRequest).then((res) => {
					if(res.data.status == 'ok') {
						imgUrl = res.data.url;
						resolve(imgUrl);
					}
				});
			})
		},
    },
}

</script>

<style scoped lang="scss">

.page-label {
    font-size: 18px;
    font-weight: 600;
}
.or-label {
    font-weight: 500;
    padding-top: 24px;
}
.input-label {
    font-size: 14px;
    font-weight: 600;
}
.text-input-group {
    display: flex;
    flex-direction: row;
    gap: 60px;
}
.input-field {
    width: 400px;
    &__date {
        width: 300px;
    }
}
.schedule {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.v-select-input {
    display: flex;
    flex-direction: row;
    gap: 30px;
}
.v-select {
    width: 400px;
}
.letter_construct .pattern_container {
    display: block;
    position: absolute;
    top: 30px;
    left: 260px;
    background-color: #fff;
    border: 1px solid #D1D1D1;
    border-radius: 5px;
}

.letter_construct .pattern_inner {
    line-height: 38px;
    padding: 0 24px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
}

.letter_construct .pattern_inner:hover {
    background-color: #1aa2fd;
    color: #fff;
}

.letter_construct .editor_container {
    position: relative;
}

.template-add-controls {
    &__letter-buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0px 0px 20px 0px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        margin: 0px 0px 20px 0px;
        gap: 18px;
        justify-content: space-between;
    }
}

.blue {
    color: #0678F4;
    font-size: 14px;
}

.black {
    color: black;
    font-size: 14px;
}

.left-side {
    display: flex;
    flex-direction: row;
    flex: 3;
}

.right-side {
    display: flex;
    flex-direction: row;
    flex: 2;
    justify-content: flex-end
}

#saveButton {
    padding: 0px 72px;
}

#previewButton {
    padding: 0px 30px;
}

#HTMLButton {
    padding: 0px 30px;
}

#cancelButton {
    padding: 0px 42px;
}

.mailing {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }
}

.selected-reciever {
    border: 1px solid #EAEEF4;
    border-radius: 5px;
    padding: 5px 8px;
    &__button {
        cursor: pointer;
    }
    &__button:hover {
        path {
            stroke: red;
            transition: stroke 0.15s ease;
        }
    }
}

</style>
